import {SET_INTERPRETATIONS} from '../actions/types';


const interpretations = (state = null, action) => {
  switch (action.type) {
    case SET_INTERPRETATIONS:
      return action.payload;
    default:
      return state;
  }
};

export default interpretations;